import { render, staticRenderFns } from "./SkipNav.vue?vue&type=template&id=52062f36&"
import script from "./SkipNav.vue?vue&type=script&lang=js&"
export * from "./SkipNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports